const convertMsToMinutes = time => {
  return time / 60000
}

export default convertMsToMinutes
